<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <table class="table table-striped jambo_table bulk_action">
        <!--head-->
        <thead>
          <tr class="headings">
            <th
              v-for="head in HEAD"
              @click="filterByTitle(head.name)"
              :key="head.title"
              :width="head.width"
              :class="{ headHover: head.name }"
              class="column-title"
            >
              {{ head.title }}
            </th>
            <th class="column-title no-link last">
              <span class="nobr">檢視</span>
            </th>
            <th class="bulk-actions" colspan="7">
              <a class="antoo">
                Bulk Actions (
                <span class="action-cnt" />
                )
                <i class="fa fa-chevron-down" />
              </a>
            </th>
            <th class="column-title no-link last">
              <span class="nobr">紀錄</span>
            </th>
          </tr>
        </thead>
        <!--body-->
        <tbody>
          <template v-for="(driver, index) in filter_list">
            <tr
              v-if="filter_list.length > 0"
              :class="{
                even: index % 2 == 0,
                odd: index % 2 != 0,
              }"
              :key="driver.id"
              class="pointer"
            >
              <td>{{ driver.call_number }}</td>
              <td>{{ driver.name }}</td>
              <td>{{ driver.group }}</td>
              <td>{{ driver.phone }}</td>
              <td>{{ driver.licence }}</td>
              <td>{{ driver.note || '' }}</td>
              <td>{{ driver.reputation }}</td>
              <td class="a-right" style="color: black; font-weight: bold">
                {{ driver.authorize }}
                <el-select
                  style="margin-left: 10px"
                  v-model="driver.authOpt"
                  placeholder="變更權限"
                  @change="
                    $emit(
                      'changeDriverAuth',
                      driver.authOpt,
                      driver.id,
                      driver.call_number,
                      driver.name,
                    )
                  "
                >
                  <el-option
                    v-for="item in AUTH_OPTIONS"
                    :value="item.value"
                    :label="item.label"
                    :key="item.value"
                  />
                </el-select>
              </td>
              <td class="last table-content">
                <a
                  class="red_textcolor"
                  v-if="permissionEditDriver"
                  :href="
                    $router.resolve({
                      name: 'driverDetail',
                      params: { id: driver.id },
                    }).href
                  "
                  target="_blank"
                >
                  檢視
                </a>
              </td>
              <td>
                <el-button size="small" @click="toRecordPage(driver.id)">
                  活動紀錄
                </el-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </el-col>
  </el-row>
</template>

<script>
import { driver } from '@/constants/tableHead'
import { authOptions } from '@/constants/select'

export default {
  props: {
    filter_list: Array,
    permissionEditDriver: Boolean,
  },
  methods: {
    toRecordPage(id) {
      const routeData = this.$router.resolve({
        name: 'activityRecord',
        query: { id: id, type: '單一司機資料' },
      })
      window.open(routeData.href, '_blank')
    },
    filterByTitle(name) {
      if (name) {
        this.$emit('onTitle', name)
      }
    },
  },
  created() {
    this.HEAD = driver
    this.AUTH_OPTIONS = authOptions
  },
}
</script>

<style scoped>
.headHover {
  cursor: pointer;
}

table.jambo_table th,
table.jambo_table td {
  vertical-align: middle;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/components/InTeamTable.vue